import script from "./Action.vue?vue&type=script&setup=true&lang=js"
export * from "./Action.vue?vue&type=script&setup=true&lang=js"

import "./Action.vue?vue&type=style&index=0&id=7d608a52&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d608a52"]])

export default __exports__